import { z } from "zod";

export const workflowReminderSchema = z.object({
    id: z.string().min(1),
    workflow_id: z.string().min(1),
    title: z.string(),
    message: z.string(),
    result_id: z.string().min(1).nullable().optional(),
    result_format: z.enum(["card", "docx"]).optional(),
    result_kind: z.enum(["shift_handover"]).nullable().optional(),
    change_kind: z.enum(["initial", "updated", "removed"]).optional(),
    result_status: z.enum(["succeeded", "failed"]).nullable().optional(),
    scheduled_at: z.string().datetime({ offset: true }),
    timezone: z.string().min(1),
    lease_token: z.string().min(1)
});

export const claimedRemindersSchema = z.object({ reminders: z.array(workflowReminderSchema).max(3) });
export type WorkflowReminder = z.infer<typeof workflowReminderSchema>;

export function reminderOccurrenceKey(reminder: WorkflowReminder): string {
    // A recovered summary can produce a new result for the same scheduled occurrence.
    return JSON.stringify(reminder.result_id
        ? [reminder.id, reminder.scheduled_at, reminder.result_id]
        : [reminder.id, reminder.scheduled_at]);
}

export function reminderResultPath(reminder: WorkflowReminder): string | null {
    return reminder.result_id ? `/app/workspace?${reminder.result_kind === "shift_handover" ? "handover" : "summary"}=${encodeURIComponent(reminder.result_id)}` : null;
}

export type ReminderNotice = {
    reminder: WorkflowReminder;
    dismissing: boolean;
    dismissFailed: boolean;
};
